export const MODULE = 'accounting';
